import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ConfService} from '../conf.service';
import {interval} from 'rxjs';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';
import {TestCaseNameInputDialog} from '../testcase/testcase.component';
import {MatDialog} from '@angular/material/dialog';
import {TestReportComponent} from '../testsuite/test-report/test-report.component';

@Component({
  selector: 'testsuite-editor',
  templateUrl: './api-testsuite-editor.component.html',
  styleUrls: ['./api-testsuite-editor.component.scss']
})
export class ApiTestsuiteEditorComponent implements OnInit {

  executor_name: any;
  executor_version: any;

  partner = localStorage.getItem('partner');
  account = localStorage.getItem('account');
  partnerKey = localStorage.getItem('partnerKey');

  testSuites: any;
  currentActiveIndex = 0;

  testSuiteResponse: any;

  selectedTab = 0;

  tabChangeLoading = false;
  componentLoading = true;
  saveLoading = false;
  testLoading = false;

  constructor(private route: ActivatedRoute,
              private router: Router,
              public confPost: ConfService,
              public dialog: MatDialog,
              public platform: LeftpanelComponent) { }

  ngOnInit() {

    if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
      this.platform.initialisePlatform();
    }

    const permissionSubscription = interval(500).subscribe((async x => {
      this.initPage();
      permissionSubscription.unsubscribe();
    }));

  }

  initPage() {
    this.route.queryParams.subscribe(async params => {
      if (params) {
        if (params.executor_name && params.executor_version) {
          this.executor_name = params.executor_name;
          this.executor_version = params.executor_version;
          this.confPost.getAPITestsuites(this.partner, this.account, this.partnerKey, this.executor_name, this.executor_version, true).subscribe(async response => {
            this.testSuites =  response;
            if (this.testSuites.length > 0) {
              this.currentActiveIndex = 0;
            }
            this.componentLoading = false;
          }, error => {
            this.router.navigateByUrl('/controlplane');
            this.platform.handleErrorGracefully(error, 'Error while fetching Test suites for executor. Please try again after sometime.');

          });
        } else {

        }
      }
    });
  }

  saveTestSuites() {
    this.saveLoading = true;
    this.confPost.updateAPITestsuites(this.partner, this.account, this.partnerKey, {
      executor_name: this.executor_name,
      executor_version: this.executor_version,
      testsuites: this.testSuites
    }).subscribe(async response => {
      this.saveLoading = false;
      this.platform.openSnackBar('API Test Suites updated successfully', 'Success', {
        duration: 4000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }, error => {
      this.saveLoading = false;
      this.platform.handleErrorGracefully(error, 'Error while saving Test suites for executor. Please try again after sometime.');

    });
  }

  runTestSuite() {
    this.testLoading = true;
    this.confPost.runAPITestsuites(this.partner, this.account, this.partnerKey, this.testSuites).subscribe(res => {
      this.testLoading = false;
      if (res) {
        this.testSuiteResponse = res;

        if (this.testSuiteResponse['testCaseResults'] !== undefined) {
          const dialogRef = this.dialog.open(TestReportComponent, {
            height: '80%',
            width: '80%',
            data: {
              testSuitePayload: {},
              testSuiteResponse: this.testSuiteResponse
            }
          });
        } else {
          this.platform.openSnackBar('Error while testing the API. Please try again after sometime.', 'Error', {
            duration: 7000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        }
      }

    }, error => {
      this.testLoading = false;
      this.platform.handleErrorGracefully(error, 'Error while testing the API. Please try again after sometime.');

    });
  }

  addTestCase() {
    const dialogRef = this.dialog.open(TestCaseNameInputDialog, {
      width: '300px',
      data: {name: '', type: 'Test Suite'}
    });
    dialogRef.afterClosed().subscribe(name => {
      if (name) {
        if (name !== '' && name !== ' ') {
          const duplicateTestCases = this.testSuites.filter((v, i) => v.name === name);
          if (!duplicateTestCases.length) {
            this.testSuites.push(
                {
                  'name': name,
                  'baseExecutorModel': {
                    'executor_type': 'API',
                    'executor_version': 'v1',
                    'executor_method_type': 'GET',
                    'apiUrl': '',
                    'dataroot': null,
                    'queryParams': [],
                    'pathParams': [],
                    'headers': [
                      {
                        'key': 'Content-Type',
                        'value': 'application/json',
                        'description': '',
                        'req': false
                      },
                      {
                        'key': 'pkey',
                        'value': '',
                        'description': ''
                      },
                      {
                        'key': 'apikey',
                        'value': '',
                        'description': ''
                      }
                    ],
                    'requestBody': {
                      'value': {},
                      'key': 'payload',
                      'description': 'Document in JSON format',
                      'annotation': 'RequestBody'
                    },
                    'prerequisites': null
                  },
                  'preSteps': [],
                  'tearDownSteps': [],
                  'testCases': [],
                  'isEnabled': true
                }
            );
            this.currentActiveIndex = this.testSuites.length - 1;
          } else {
            this.platform.openSnackBar('Test Suite named ' + name + ' already exists', 'Error', {
              duration: 4000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
            this.addTestCase();
          }

        } else {
          this.addTestCase();
        }
      }
    });
  }

  deleteTestSuite(i) {
    if (confirm('Are you sure you want to delete this Test suite?')) {
      this.testSuites.splice(i, 1);
      if (this.testSuites.length > 0) {
        if (!(this.currentActiveIndex < this.testSuites.length)) {
          this.currentActiveIndex = this.testSuites.length - 1;
        }
      } else {
        this.currentActiveIndex = -1;
      }
    }
  }

  editTestCaseName(testsuite) {
    const val = testsuite.name;
    const dialogRef = this.dialog.open(TestCaseNameInputDialog, {
      width: '300px',
      data: {name: val, type: 'Test Suite'}
    });
    dialogRef.afterClosed().subscribe(name => {
      if (name) {
        if (name !== '' && name !== ' ') {
          if (val !== name) {
            const duplicateTestCases = this.testSuites.filter((v, i) => v.name === name);
            if (!duplicateTestCases.length) {
              testsuite.name = name;
            } else {
              this.platform.openSnackBar('Test Suite named ' + name + ' already exists', 'Error', {
                duration: 4000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
              });
              this.editTestCaseName(testsuite);
            }
          }

        } else {
          this.platform.openSnackBar('Test Suite name cannot be empty', 'Error', {
            duration: 4000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
          this.editTestCaseName(testsuite);
        }
      }
    });
  }

  setResult(suiteName, i) {
    this.currentActiveIndex = i;
    this.selectedTab = 0;
    this.tabChangeLoading = true;
    setTimeout(() => {
      this.tabChangeLoading = false;
    }, 100);
  }

  tabChanged(event) {
    this.selectedTab = event.index;
  }

  testCasesCompleted(s) {}
  teardownCompleted(s) {}
  prestepsCompleted(s) {}

}
